import { ColumnDef } from './types';

export const COLUMNS: ColumnDef[] = [
  { key: 'player', label: 'Player', defaultWidth: 150, align: 'left' },
  { key: 'pos', label: 'Pos', defaultWidth: 50 },
  { key: 'min', label: 'Min', defaultWidth: 55, sortField: 'minutesOnField' },
  { key: 'goals', label: 'G', defaultWidth: 40, sortField: 'goals' },
  { key: 'assists', label: 'A', defaultWidth: 40, sortField: 'assists' },
  { key: 'xg', label: 'xG', defaultWidth: 55, sortField: 'xgShot' },
  { key: 'shots', label: 'Sh', defaultWidth: 45, sortField: 'shots' },
  { key: 'sot', label: 'SoT', defaultWidth: 50, sortField: 'shotsOnTarget' },
  { key: 'pass', label: 'Pass', defaultWidth: 55, sortField: 'passes' },
  { key: 'cmp', label: 'Cmp', defaultWidth: 55, sortField: 'successfulPasses' },
  { key: 'kp', label: 'KP', defaultWidth: 45, sortField: 'keyPasses' },
  { key: 'duel', label: 'Duel', defaultWidth: 50, sortField: 'duels' },
  { key: 'won', label: 'Won', defaultWidth: 50, sortField: 'duelsWon' },
  { key: 'int', label: 'Int', defaultWidth: 45, sortField: 'interceptions' },
  { key: 'rec', label: 'Rec', defaultWidth: 45, sortField: 'recoveries' },
  { key: 'cards', label: 'Cards', defaultWidth: 55 },
];

export const MIN_COL_WIDTH = 30;
export const MAX_COL_WIDTH = 400;
